import Attribute from "vueforms/src/xmlrdb-metadata/Attribute"

Attribute.ValidatorFunctionRegistry["USERNAME"] = (attr) => {
  const username = attr.value;
  if (!username){
    return "Benutzername ist leer. Das Feld Benutzername ist ein Pflichtfeld";
  }
  if (username.length < 4){
    return "Benutzername ist zu kurz. Der Benutzername muss mindestens 4 Zeichen enthalten";
  }
  if (username.search(/^[a-zA-Z0-9ßäöüÄÖÜ_. -]+$/) == -1){
    return "Benutzername enthält ungültige Zeichen";
  }
}

Attribute.ValidatorFunctionRegistry["NACHNAME"] = (attr) => {
  const nachname = attr.value;
  if (!nachname){
    return "Nachname ist leer. Das Feld Nachname ist ein Pflichtfeld";
  }
  if (nachname.length < 2){
    return "Nachname ist zu kurz. Der Nachname muss mindestens 2 Zeichen enthalten";
  }
  if (nachname.search(/^[a-zA-ZßäöüÄÖÜ. -]+$/) == -1){
    return "Nachname enthält ungültige Zeichen";
  }
}

Attribute.ValidatorFunctionRegistry["VORNAME"] = (attr) => {
  const vorname = attr.value;
  if (!vorname){
    return "Vorname ist leer. Das Feld Vorname ist ein Pflichtfeld";
  }
  if (vorname.length < 2){
    return "Vorname ist zu kurz. Der Vorname muss mindestens 2 Zeichen enthalten";
  }
  if (vorname.search(/^[a-zA-ZßäöüÄÖÜ. -]+$/) == -1){
    return "Vorname enthält ungültige Zeichen";
  }
}

Attribute.ValidatorFunctionRegistry["EMAIL"] = (attr) => {
  const email = attr.value;
  if (!email){
    return "Email ist leer. Das Feld Email ist ein Pflichtfeld";
  }
  if (email.search(/^[A-Za-z0-9.@_-]+$/) == -1) {
    return "Email enthält ungültige Zeichen";
  }
  if (email.search(/[^@]+[@]{1}[^@]+[.]{1}[^@]{2,30}$/) == -1) {
    return "Email besitzt ungültiges Format";
  }
}

Attribute.ValidatorFunctionRegistry["TELEFON"] = (attr) => {
  const telefon = attr.value;
  if (!telefon){
    return "Telefonnummer ist leer. Das Feld Telefonnummer ist ein Pflichtfeld";
  }
  if (telefon.length < 6){
    return "Telefonnummer ist zu kurz. Die Telefonnummer muss mindestens 6 Zeichen enthalten";
  }
  if (telefon.search(/^[0-9+/ -]+$/) == -1) {
    return "Telefonnummer enthält ungültige Zeichen";
  }
  if (!telefon.startsWith("0") && !telefon.startsWith("+")) {
    return "Telefonnummer muss mit '0' oder '+' beginnen";
  }
}

Attribute.ValidatorFunctionRegistry["FUNKTION"] = (attr) => {
  const funktion = attr.value;
  if (!funktion){
    return "Funktion ist leer. Das Feld Funktion ein Pflichtfeld";
  }
}

Attribute.ValidatorFunctionRegistry["MTNAME"] = (attr) => {
  const mtname = attr.value;
  if (!mtname){
    return "Name ist leer. Das Feld Name ist ein Pflichtfeld";
  }
}

Attribute.ValidatorFunctionRegistry["MTSTRASSE"] = (attr) => {
  const mtstrasse = attr.value;
  if (!mtstrasse){
    return "Straße ist leer. Das Feld Straße ist ein Pflichtfeld";
  }
}

Attribute.ValidatorFunctionRegistry["MTHAUSNR"] = (attr) => {
  const mthausnr = attr.value;
  if (!mthausnr){
    return "Hausnummer ist leer. Das Feld Hausnummer ist ein Pflichtfeld";
  }
}

Attribute.ValidatorFunctionRegistry["MTPLZ"] = (attr) => {
  const mtplz = attr.value;
  if (!mtplz){
    return "Postleitzahl ist leer. Das Feld Postleitzahl ist ein Pflichtfeld";
  }
  if (mtplz.search(/^[0-9]+$/) == -1) {
    return "Postleitzahl enthält ungültige Zeichen. Die Postleitzahl darf nur Zahlen enthalten";
  }
  if (mtplz.length < 5){
    return "Postleitzahl ist zu kurz. Die Postleitzahl muss genau 5 Zahlen enthalten";
  }
}

Attribute.ValidatorFunctionRegistry["MTORT"] = (attr) => {
  const mtort = attr.value;
  if (!mtort){
    return "Ort ist leer. Das Feld Ort ist ein Pflichtfeld";
  }
  if (mtort.search(/^[a-zA-ZßäöüÄÖÜ. -]+$/) == -1){
    return "Ort enthält ungültige Zeichen";
  }
}